import { StringLocalized } from '../../shared/string-localized';
import { CompletenessStatus } from '../enums/completeness-status';

export interface WizardStepDto {
  status: CompletenessStatus;
  name: StringLocalized;
  description: StringLocalized;
  explanation?: StringLocalized;
  stage: WizardStepStage;
  hasOptionSelected: boolean;
  isOptional: boolean;
  isNextButtonHidden?: boolean;
  isBackButtonHidden?: boolean;
  onStepOpened?: (wasNavigationForward: boolean) => void;
}

export enum WizardStepStage {
  VariationSelection,
  PaperSizeSelection,
  PaperTypeSelection,
  PrintStyleSelection,
  ExtrasSelection,
  PrintOfficeSelection,
  FilesSelection,
  Payment,
  Unknown,
}
